import axios from 'axios';

/**
 * 라우트가 없을 때 게이트웨이가 돌려주는 404 응답 본문.
 * 문서 404 와 status 가 같아, 이 문구를 걸러내지 않으면 엔드포인트 미배포 구간에서
 * 사용자에게 "문서를 찾을 수 없습니다" 라는 엉뚱한 안내가 나간다.
 */
const MISSING_ROUTE_MESSAGE = 'Not found api';

/**
 * 반려요청 실패 시 status code → 사용자 메시지(번역 key) 매핑.
 *
 * 422 는 서버 문구를 그대로 key 로 쓴다 — 거절 사유가 상태별로 갈리고, 문구는 서버가 단일 출처다.
 * 완료 문서 거절 문구는 PORTAL-3406 에서 3개 국어로 확정된 것이라 번역 파일에 그대로 실려 있다.
 */
export const getRequestReturnErrorMessage = (error: unknown): string => {
  if (!axios.isAxiosError(error)) return '반려요청에 실패했습니다.';
  const serverMessage = error.response?.data?.message as string | undefined;
  switch (error.response?.status) {
    case 403:
      return '본인이 작성한 문서만 반려요청할 수 있습니다.';
    case 404:
      return serverMessage === MISSING_ROUTE_MESSAGE
        ? '반려요청에 실패했습니다.'
        : '문서를 찾을 수 없습니다.';
    case 422:
      return serverMessage || '반려요청 가능한 상태가 아닙니다.';
    default:
      // 5xx 는 서버 내부 문구(오라클 에러 등)가 실릴 수 있어 그대로 노출하지 않는다.
      // 서버 문구를 key 로 쓰는 것은 사용자에게 보여줄 안내로 확정된 4xx 에서만.
      return (error.response?.status ?? 500) >= 500
        ? '반려요청에 실패했습니다.'
        : serverMessage || '반려요청에 실패했습니다.';
  }
};
